// eslint-disable-next-line no-shadow
export enum StatusOfferVehicle {
	offer = 'offer',
	reached = 'reached',
	bought = 'bought',
	rejected = 'rejected',
}
export const StatusOfferVehicleValues = {
	offer: {
		title: 'Ofertado',
		color: 'secondary_600',
		tooltip: 'Oferta sin atender',
	},
	reached: {
		title: 'Contatado',
		color: 'primary_300',
		tooltip: 'Oferta en progreso',
	},
	bought: {
		title: 'Comprada',
		color: 'green_300',
		tooltip: 'Oferta aceptada',
	},
	rejected: {
		title: 'Rechazada',
		color: 'red_300',
		tooltip: 'Oferta rechazada',
	},
};
// eslint-disable-next-line no-shadow
export enum CreatedOnType {
	webpage = 'webpage',
	pandaboard = 'pandaboard',
}
// eslint-disable-next-line no-shadow
export enum OfferVehicleType {
	sale = 'sale',
	consignmentSale = 'consignmentSale',
}
export const OfferVehicleTypeValues = {
	[OfferVehicleType.sale]: {
		title: 'Venta',
		color: 'neutral_500',
		tooltip: 'Modelo anterior a venta por consignación',
	},
	[OfferVehicleType.consignmentSale]: {
		title: 'Venta en consignación',
		color: 'primary_200',
		tooltip: 'Venta en consignación',
	},
};

export interface OzocioInspectionAppointment {
	startTime: Date;
	endTime: Date;
	url?: string;
}

export interface OfferVehicle {
	_id: string;
	year: number;
	km: number;
	brand: string;
	model: string;
	cylinderCapacity: string;
	amountOffer: number;
	status: StatusOfferVehicle;
	statusHistoric: any;
	createdAt: string;
	updatedAt: string;
	comment: string;
	askingPrice: number;
	sellReason?: string;
	type: OfferVehicleType;
	inspectionAppointment: OzocioInspectionAppointment;
}
export interface TOzocio {
	name: string;
	phone: string;
	dialCode: string;
	email: string;
	address: string;
	OfferVehicles: OfferVehicle[];
	createdOn: CreatedOnType;
	reachedBy: string;
	createdAt: string;
	updatedAt: string;
	_id: string;
}
export interface TOzocioOneOffer {
	_id: string;
	name: string;
	phone: string;
	dialCode: string;
	email: string;
	address: string;
	OfferVehicles: OfferVehicle;
	createdOn: CreatedOnType;
	reachedBy: string;
	createdAt: string;
	updatedAt: string;
}
